module.exports = __webpack_public_path__ + "img/ori_img_3.d62d3d19.png";